import React from 'react'
import {Link} from 'react-router-dom'
import OwlCarousel from 'react-owl-carousel'
import 'owl.carousel/dist/assets/owl.carousel.css'
import 'owl.carousel/dist/assets/owl.theme.default.css'
import GameProducer from '../components/GameProducer'
import games from '../assets/social-games'
import imgMystiJackFooter from '../assets/imgs/mysti-jack-footer.png'
import imgMysti from '../assets/imgs/Mysti-cards2 1.png'
import imgJack from '../assets/imgs/Jack-standing 1.png'
import imgJackMobile from '../assets/imgs/jack-mobile.png'
import imgTailPink from '../assets/imgs/TailPink.png'
import imgTail from '../assets/imgs/Tail.png'
import imgTailLeft from '../assets/imgs/Tail-left.png'
import imgTailMys from '../assets/imgs/tall-left-mysti.png'
import imgTailBottom from '../assets/imgs/tail-bottom.png'
import textBanner from '../assets/imgs/Group 1859.png'
import headerImageMobile from '../assets/imgs/Mystino-home-m.jpg'
import headerLoginImage from '../assets/imgs/Mystino-home.jpg'
import headerRegisterImage from '../assets/imgs/Mystino-home.jpg'
import {Helmet} from "react-helmet"

const gameProducers = [
    {
        image: require('../assets/imgs/game_producers/netent.png'),
        title: 'NETENT',
        link: '/netent'
    },
    {
        image: require('../assets/imgs/game_producers/yggdrasil-gaming.png'),
        title: 'Evolution Gaming',
        link: '/evolution'
    },
    {
        image: require('../assets/imgs/game_producers/jtg-logo.png'),
        title: 'JTG',
        link: '/jtg'
    },
    {
        image: require('../assets/imgs/game_producers/playgo.png'),
        title: "Play'n Go",
        link: '/playgo'
    },
    {
        image: require('../assets/imgs/game_producers/microgaming.png'),
        title: 'Blaze of Ra',
        link: 'blazeofra'
    }
]


class NewHomepage extends React.Component {
    owlCarouselOptions = {
        items: 5,
        margin: 5,
        stagePadding: 20,
        nav: false,
        rewind: true,
        autoplay: true,
        responsive: {
            0: {
                items: 2,
                nav: true
            },
            720: {
                items: 2,
                nav: true
            },
            1000: {
                items: 5,
                nav: true
            },
        },
    }

    constructor(props) {
        super(props);

        this.state = {
            gameList: [],
            gameLaunchUrl: "",
            errorMessage: "",
            limit: 25,
            showLoadMoreButton: true,
            numberOfGames: 0,
            matches: window.matchMedia("(max-width: 768px)").matches
        }

        this.loadMore = this.loadMore.bind(this);
    }

    componentDidMount() {
        let newGames = [];

        games.map((game, indexGame) => {
            const gamesCanPlay = [
                "hawaiian_dream.goldenhero",
                "baccarat.netent",
                "golden_chip_roulette.yggdrasil",
            ];
            let canPlay = false;

            if (gamesCanPlay.includes(game.id)) {
                canPlay = true;
            }

            newGames.push({
                id: game.id,
                name: game.name,
                image: game.thumbnailUrl,
                metaTitle: game.metaTitle,
                shortDescription: game.shortDescription,
                canPlay: canPlay,
                gameIframe: false
            });

            if (indexGame === 2) {
                newGames.push({
                    id: 'jack',
                    text: '新CM公開中',
                    class: 'banner-game',
                    classText: 'text-iframe',
                    gameIframe: true,
                    urlIframe: 'https://www.youtube.com/embed/srj4edde4W8'
                });
            }

            if (indexGame === 26) {
                newGames.push({
                    id: 'mysti',
                    text: 'たくさんのドキドキが待っているミスティーノの世界はもう訪れましたか？',
                    class: 'banner-game2',
                    classText: 'text-iframe2',
                    gameIframe: true,
                    urlIframe: 'https://www.youtube.com/embed/G6zRhgg3CGU'
                });
            }
        })

        this.setState({
            gameList: newGames,
        });
    }

    loadMore = (e) => {
        e.preventDefault();

        if (this.state.limit + 31 >= this.state.gameList.length) {
            this.setState({showLoadMoreButton: false})
        }

        this.setState({limit: this.state.limit + 31})
    }

    showIframe(me, urlIframe) {
        localStorage.setItem('urlIframe', urlIframe)
        return me.props.showIframeModal
    }

    //helpere
    showGames = (playAllGames) => {
        return this.state.gameList.slice(0, this.state.limit).map((game, index) => {
            let link;
            let gameBlur = '';

            if (playAllGames !== true) {
                if (game.canPlay === true) {
                    link = <Link to={`/game/` + game.id} className="play2 button">Play</Link>
                } else {
                    if (localStorage['isReturnVisitor']) {
                        link = <div className='div-homepage-register'><a className='button-register'
                                                                         onClick={this.props.showLoginModal}>ログインしてプレイ</a>
                        </div>
                    } else {
                        link = <div className='div-homepage-register'><a className='button-register'
                                                                         onClick={this.props.showModal}>新規登録してプレイ</a>
                        </div>
                    }

                    gameBlur = 'game-blur'
                }
            } else {
                link = <Link to={`/game/` + game.id} className="play2 button">Play</Link>
            }


            return (
                <div key={index}>
                    {
                        ((playAllGames !== false || game.canPlay === true) && !game.gameIframe) ?
                            <div className='game__card'>
                                <div className="game-text">今すぐプレイ</div>
                                <Link to={`/game/` + game.id} className='game-card-link'>
                                    <img className={"game__card--image " + gameBlur}
                                         src={require("../assets/imgs/games_imgs/" + game.id + ".jpeg")} alt=''/>
                                    <p className='game__card--title'>{game.name}</p>
                                </Link>
                                <p className='game__card--subtitle'>{game.shortDescription}</p>
                                {link}
                            </div>
                            : (!game.gameIframe) ?
                                <div className={'game__card'}>
                                    <img className={"game__card--image " + gameBlur}
                                         src={require("../assets/imgs/games_imgs/" + game.id + ".jpeg")} alt=''/>
                                    <p className='game__card--title'>{game.name}</p>
                                    <p className='game__card--subtitle'>{game.shortDescription}</p>
                                    {link}
                                </div>
                            :
                                <div className={'game__card ' + game.class}
                                     onClick={this.showIframe(this, game.urlIframe)}>
                                    <img className={"game__card--image "}
                                         src={require("../assets/imgs/games_imgs/" + game.id + ".png")} alt=''/>
                                    <p className={game.classText}>{game.text}</p>
                                </div>
                    }
                </div>

            )
        })
    }

    showGameProducers = () => {
        window.getSelection().empty()
        return gameProducers.map((elem, index) => (
            <GameProducer
                key={index}
                image={elem.image}
                link={elem.link}
            />
        ))
    }

    render() {

        let contentGames = "";
        let playAllGames = false;
        let headerImage = headerRegisterImage;
        let CtaHeader = <a className="button-register" onClick={this.props.showModal}>新規登録はこちら</a>
        let showMoreContent = <div className="text-center bg-mobile p-10">
            <a href='#' onClick={this.loadMore} className='slideshow__container--button'>
                すべてのゲームを見る
            </a>
        </div>;

        if (this.props.currentUser) {
            playAllGames = true;

        }

        contentGames = this.showGames(playAllGames);

        if (!this.state.showLoadMoreButton) {
            showMoreContent = "";
        }

        if (localStorage['isReturnVisitor']) {
            headerImage = headerLoginImage;
            CtaHeader = <a className="button-register" onClick={this.props.showLoginModal}>ログイン</a>
        }
        if(this.state.matches){
            headerImage = headerImageMobile
        }

        return (
            <div className='homepage__container'>
                <Helmet>
                    <title>ミスティーノFREE | 無料オンラインカジノゲーム</title>
                </Helmet>
                <div className="pink__band ho"><Link to={'/domains'}>.jp </Link>&nbsp;なら、リアルマネーが一切かかりません！<Link to={'/domains'}>ドメインについて </Link></div>
                <div className="bg-img-homepage">
                    <div className="container banner-container">
                        <img className="img-mysti" src={imgMysti}/>
                        <img src={imgJack} className="right-0 img-jack"/>
                        <img src={imgJackMobile} className="right-0 img-jack-mobile"/>
                        <img src={textBanner} className="text-banner"/>
                        <div className="row h-100">
                            <div className="col-md-8 ml-auto mr-auto">
                                <p className="first-text"><img className="hidden-mobile" src={imgTailLeft}/><img className="hidden"  src={imgTailMys}/><span>リアルマネーを使って勝負したい！</span></p>
                                <p className="second-text"><span>ミスティ、ここは無料プレイのサイトなんだなぁ。</span><img src={imgTail}/> <img className="hidden" src={imgTailBottom}/></p>
                                <p className="last-text"><img src={imgTailLeft}/><span>そっか、<span>.jp</span>は無料版だよね！</span></p>
                            </div>
                        </div>

                    </div>
                </div>

                <div className='game__container'>
                    {contentGames}
                </div>
                {showMoreContent}
                {/*<div className='gameproducers__container'>*/}
                {/*    <p className='gameproducers__container--title text-center'>ゲームプロバイダー</p>*/}
                {/*    <div className="row">*/}
                {/*        <div className="col-md-10 col-lg-10 ml-auto mr-auto">*/}
                {/*            <OwlCarousel className='owl-theme' {...this.owlCarouselOptions}>*/}
                {/*                {this.showGameProducers()}*/}
                {/*            </OwlCarousel>*/}
                {/*        </div>*/}
                {/*    </div>*/}

                {/*</div>*/}
                <div className="img-footer"><img src={imgMystiJackFooter}/> <span><img src={imgTailPink}/>またお待ちしております！</span></div>

            </div>
        )
    }
}

export default NewHomepage
